'use strict';

const get = require('lodash.get');

/**
 * Returns the value of an itemTag's attribute
 *
 * @param {object}        itemTag
 * @param {string}        attr
 * @param {number|string} [index]
 * @returns {string}
 */
function getAttributeValue(itemTag = {}, attr = '', index = 0) {
    return get(itemTag, `attributeProfile.dataMap.${attr}[${index}].value`, '');
}

/**
 * Return's the itemTag's categoryKey (from its attributeProfile)
 *
 * @param {object} itemTag
 * @param {string} itemTag.attributeProfile.dataMap.categoryKey[0].value
 * @returns {string}
 */
function getCategoryKey(itemTag) {
    return getAttributeValue(itemTag, 'categoryKey');
}

/**
 * Return's the itemTag's creatorId (from its attributeProfile)
 *
 * @param {object} itemTag
 * @param {string} itemTag.attributeProfile.dataMap.creatorId[0].value
 * @returns {string}
 */
function getCreatorId(itemTag) {
    return getAttributeValue(itemTag, 'creatorId');
}

module.exports = {
    getCategoryKey,
    getCreatorId,
};



// WEBPACK FOOTER //
// ./assets/js/gallery/helpers/itemTagHelpers.es.js